import { render, staticRenderFns } from "./SalariePrintTotal.vue?vue&type=template&id=0ab069e1&scoped=true"
import script from "./SalariePrintTotal.vue?vue&type=script&lang=js"
export * from "./SalariePrintTotal.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintTotal.vue?vue&type=style&index=0&id=0ab069e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab069e1",
  null
  
)

export default component.exports